import { library } from '@fortawesome/fontawesome-svg-core'

import {
  faPencilAlt,
  faPaperclip,
  faEye,
  faStar,
  faThumbtack,
  faFile
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faPencilAlt,
  faPaperclip,
  faEye,
  faStar,
  faThumbtack,
  faFile
)

const queries = `
  mutation publish($id: ID!, $state: Boolean!) { flag: contentflags( id: $id, published: $state) {id, published} }
  mutation feature($id: ID!, $state: Boolean!) { flag: contentflags( id: $id, featured: $state) {id, featured}}
  mutation sticky($id: ID!, $state: Boolean!) { flag: contentflags( id: $id, sticky: $state) {id, sticky}}
`

const viewHandler = function(item) {
  if (!(this.isViewItemPath || this.options.mode === 'view') && !this.options.hideView && this.checkPermissions(item, 'view')) {
    return {
      title: 'View',
      uri: item.path ? item.path : `/node/${item.nid}`,
      icon: 'pencil-alt'
    }
  }
}

const editHandler = function(item) {
  if ((!this.isEditItemPath || this.options.showEdit) && this.checkPermissions(item, 'update')) {
    return {
      title: 'Edit Content',
      uri: (!this.options.destination) ? `/node/${item.nid}/edit` : `/node/${item.nid}/edit?destination=${this.options.destination}`,
      icon: 'eye'
    }
  }
}

const publishHandler = function(item) {
  if ((this.isViewItemPath || this.options.mode === 'view' || this.options.showpublish) && this.checkPermissions(item, 'publish')) {
    if (item.status === '0') {
      return {
        title: 'Publish',
        func: () => {
          return this.updateQuery({opName: 'publish', variables: {id: item.nid, state: true}})
            .then(result => {
              this.store.commit('node/UPDATE_CONTENT_FLAGS', {nid: result.data.flag.id, status: result.data.flag.published})
            })
        },
        icon: 'paperclip'
      }
    }
    else {
      return {
        title: 'Unpublish',
        func: () => {
          return this.updateQuery({opName: 'publish', variables: {id: item.nid, state: false}})
            .then(result => {
              this.store.commit('node/UPDATE_CONTENT_FLAGS', {nid: result.data.flag.id, status: result.data.flag.published})
            })
        },
        icon: 'paperclip'
      }
    }
  }
}

const featureHandler = function(item) {
  if ((this.isViewItemPath || this.options.mode === 'view' || this.options.showfeature) && this.checkPermissions(item, 'update')) {
    if (item.promote === '0') {
      return {
        title: 'Feature',
        func: () => {
          return this.updateQuery({opName: 'feature', variables: {id: item.nid, state: true}})
            .then(result => {
              this.store.commit('node/UPDATE_CONTENT_FLAGS', {nid: result.data.flag.id, promote: result.data.flag.featured})
            })
        },
        icon: 'star'
      }
    }
    else {
      return {
        title: 'Unfeature',
        func: () => {
          return this.updateQuery({opName: 'feature', variables: {id: item.nid, state: false}})
            .then(result => {
              this.store.commit('node/UPDATE_CONTENT_FLAGS', {nid: result.data.flag.id, promote: result.data.flag.featured})
            })
        },
        icon: 'star'
      }
    }
  }
}

const stickyHandler = function(item) {
  if ((this.isViewItemPath || this.options.mode === 'view' || this.options.showsticky) && this.checkPermissions(item, 'update')) {
    if (item.sticky === '0') {
      return {
        title: 'Sticky',
        func: () => {
          return this.updateQuery({opName: 'sticky', variables: {id: item.nid, state: true}})
            .then(result => {
              this.store.commit('node/UPDATE_CONTENT_FLAGS', {nid: result.data.flag.id, sticky: result.data.flag.sticky})
            })
        },
        icon: 'thumbtack'
      }
    }
    else {
      return {
        title: 'Unsticky',
        func: () => {
          return this.updateQuery({opName: 'sticky', variables: {id: item.nid, state: false}})
            .then(result => {
              this.store.commit('node/UPDATE_CONTENT_FLAGS', {nid: result.data.flag.id, sticky: result.data.flag.sticky})
            })
        },
        icon: 'thumbtack'
      }
    }
  }
}

const formsHandler = function(item) {
  let userCanView = this.store.getters['user/checkPermissions']('access all webform results')

  if (userCanView) {
    if (item && item.body) {
      try {
        const itemBody = JSON.parse(item.body)

        if (itemBody.slices) {
          const slices = itemBody.slices
          const hasForms = slices.some(slice => {
            return slice.type === 'form'
          })

          if (hasForms) {
            return {
              title: 'Form Submissions',
              uri: `/node/${item.nid}/formsubmissions`,
              icon: 'file'
            }
          }
        }
      }
      catch (_) {
      // Item body does not contain a valid JSON string. Do nothing.
      }
    }
  }
}

export default function(item, store, router, options) {
  const helper = {
    store,
    router,
    options,
    isViewItemPath: (router.currentRoute.path === `/${item.path}` || router.currentRoute.path === `/node/${item.nid}`),
    isEditItemPath: (router.currentRoute.path === `/${item.path}/edit` || router.currentRoute.path === `/node/${item.nid}/edit`),
    updateQuery: store.getters['getGraphQLClient'](null, queries).query,
    checkPermissions: (item, op) => store.getters['node/itemAccess'](item.nid, op)
  }
  const handlers = [
    viewHandler,
    editHandler,
    publishHandler,
    featureHandler,
    stickyHandler,
    formsHandler
  ]

  return handlers.map(f => f.call(helper, item)).filter(_ => _)
}
